import { render, staticRenderFns } from "./ShopLogoInput.vue?vue&type=template&id=09c8a4f8&scoped=true&"
import script from "./ShopLogoInput.vue?vue&type=script&lang=js&"
export * from "./ShopLogoInput.vue?vue&type=script&lang=js&"
import style0 from "./ShopLogoInput.vue?vue&type=style&index=0&id=09c8a4f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c8a4f8",
  null
  
)

export default component.exports